import * as React from 'react';
import {
  Autocomplete,
  Checkbox,
  FormControlLabel,
  Switch,
  TextField
} from "@mui/material";
import {useEffect, useState} from "react";
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';
import {LocalizationProvider} from '@mui/x-date-pickers/LocalizationProvider';
import {DatePicker} from '@mui/x-date-pickers/DatePicker';
import 'dayjs/locale/ru';
import dayjs from "dayjs";
import InputMask from "react-input-mask";
import {getAddressAutocomplete} from "../../../pages/deal/deal";
import {waitInputComplete} from "../../../fn";
import {ruRU} from "@mui/x-date-pickers/locales";

export function FormInput(props) {
  const {className, name} = props;
  return (
    <TextField
      id={props?.elemId}
      label={props.label}
      fullWidth={props.fullWidth}
      defaultValue={props.value}
      helperText={props.helperText}
      variant="outlined"
      inputProps={{className, name, ...props.inputProps}}
      onChange={props.onChange}
      multiline={!!props.multiline}
      size="small"
      hidden={props.hidden}
      rows={props?.rows}
      sx={props.sx || {width: '230px'}}
      slotProps={{
        inputLabel: {
          shrink: true,
        },
        ...props.slotProps
      }}
      disabled={props.disabled}
      required={props.required}
      error={props.error}
    />
  );
}

export function FormInputCtrl(props) {
  const [value, setValue] = useState(props.value);
  const [initialValue, setInitilValue] = useState(props.value);
  const {className, name} = props;
  useEffect(() => {
    if (initialValue !== props.value) {
      setValue(props.value);
      setInitilValue(props.value);
    }
  })

  return (
    <TextField
      id={props?.elemId}
      label={props.label}
      value={value}
      onChange={(event) => {
        props.onChange ? props.onChange(event) : void 0;
        setValue(event.target.value);
      }}
      onBlur={props.onBlur ? props.onBlur : void 0}
      helperText={props.helperText}
      variant="outlined"
      inputProps={{className, name, ...props.inputProps}}
      multiline={!!props.multiline}
      size="small"
      hidden={props.hidden}
      rows={props?.rows}
      sx={{width: props?.width || 230}}
      slotProps={{
        inputLabel: {
          shrink: true,
        },
        ...props.slotProps
      }}
      disabled={props.disabled}
      required={props.required}
      error={props.error}
    />
  );
}

export function Textarea(props) {
  let [state, setState] = useState(props.value);

  const {name} = props;

  return (
    <TextField
      id={props?.elemId}
      label={props.label}
      defaultValue={state}
      helperText={props.helperText}
      inputProps={{name, ...props.inputProps}}
      variant="outlined"
      onChange={(event, context) => {
        if (props?.onChange)
          props.onChange(event);

        setState(event.target.value);
      }}
      multiline={!!props.multiline}
      size="sm"
      sx={{width: 230}}
      rows={props?.rows}
    />
  );
}

export function TextareaCtrl(props) {
  const [value, setValue] = useState(props.value);
  const [initialValue, setInitilValue] = useState(props.value);

  const {name} = props;

  useEffect(() => {
    if (initialValue !== props.value) {
      setValue(props.value);
      setInitilValue(props.value);
    }
  })

  return (
    <TextField
      id={props?.elemId}
      label={props.label}
      value={value}
      helperText={props.helperText}
      inputProps={{name, ...props.inputProps}}
      variant="outlined"
      error={props.error}
      onChange={(event, context) => {
        if (props?.onChange)
          props.onChange(event);

        setValue(event.target.value);
      }}
      sx={{width: props?.width || 230}}
      multiline={!!props.multiline}
      size="sm"
      rows={props?.rows}
    />
  );
}

export function FormInputDate({label, className, value, name, inputProps, onChange, disabled, error, required}) {
  let [state, setState] = useState(value || null);
  const customLocaleText = ruRU.components.MuiLocalizationProvider.defaultProps.localeText;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ru">
      <DatePicker
        className={className}
        name={name}
        inputRef={{className, ...inputProps}}
        onChange={(val, context) => {
          const date = val?.format('YYYY-MM-DD');
          onChange ? onChange(date) : void 0;
          setState(date);
        }}
        size="small"
        label={label}
        localeText={customLocaleText}
        value={state ? dayjs(state) : null}
        disabled={disabled}
        required={required}
        slotProps={{textField: {size: 'small'}}}
        sx={{width: 230}}
        error={error}
      />
    </LocalizationProvider>
  );
}

export function CheckBoxWithLabel({label, className, name, inputProps, classes, checked, onChange, disabled, sx}) {
  let [state, setState] = useState(checked);

  const handleChange = (e) => {
    setState(e.target.checked)
  }

  return (
    <FormControlLabel sx={{...sx, marginRight: '5px'}} control={<Checkbox className={className}
                                                                   classes={classes}
                                                                   name={name}
                                                                   inputProps={inputProps}
                                                                   checked={state}
                                                                   disabled={disabled}
                                                                   onChange={(e) => {
                                                                     onChange ? onChange(e) : void 0;
                                                                     handleChange(e);
                                                                   }}
                                                                   value={state}
    />}
                      label={label}/>)
}

export function InputMaskBase({props, mask}) {
  const {className, name} = props;

  return (
    <InputMask
      mask={props.mask} // @TODO если ввести маску, нпаример +7(999)999-99-99, перестает печатать, разобраться попозже
      value={props.value}
      maskChar="">
      {() =>
        <TextField
          id={props?.elemId}
          label={props.label}
          fullWidth={props.fullWidth}
          defaultValue={props.value}
          helperText={props.helperText}
          variant="outlined"
          onChange={props.onChange}
          size="small"
          rows={props?.rows}
          slotProps={{
            htmlInput: {className, name, ...props.inputProps},
            inputLabel: {
              shrink: true,
            },
          }}
        />}
    </InputMask>
  );
}

export function FormInputPhone(props) {
  return (<InputMaskBase props={props}></InputMaskBase>);
}

export function FormInputSnils(props) {
  return (<InputMaskBase props={props} mask='999-999-999 99'></InputMaskBase>);
}

export function FormInputAddress({value, defaultValue, onSelect, label, width}) {
  const [options, setOptions] = useState([]);

  const onChange = async (event, value, reason) => {
    if (reason === 'input') {
      const result = await getAddressAutocomplete(event?.target?.value);
      setOptions(result || []);
    }

    if (reason === 'clear') {
      onSelect(null);
    }
  }

  const onSelectOption = async (event, option, reason) => {
    if (!option)
      return;
    onSelect ? onSelect(option) : void 0;
  }

  const waitChangeForm = waitInputComplete(onChange, 1000);

  return (
    <div>
      <Autocomplete
        disablePortal
        options={options}
        onInputChange={waitChangeForm}
        onChange={onSelectOption}
        filterOptions={(options) => options}
        defaultValue={defaultValue}
        sx={{width: width || 230}}
        size='small'
        renderInput={(params) => <TextField {...params} defaultValue={value} label={`${label || "Адрес объекта"}`}/>}
      />
    </div>
  );
}

export function FormInputAddressCtrl({defaultValue, onSelect, label, width, error}) {
  const [options, setOptions] = useState([]);
  const [value, setValue] = useState(defaultValue);
  const [initialValue, setInitialValue] = useState(defaultValue);
  const [innerState, setInnerState] = useState(false);

  useEffect(() => {
    if (initialValue !== defaultValue && !innerState) {
      setValue(defaultValue);
      setInitialValue(defaultValue);
    }
  })

  const onChange = async (event, value, reason) => {
    if (reason === 'input') {
      const result = await getAddressAutocomplete(event?.target?.value);
      setOptions(result || []);
    }

    if (reason === 'clear') {
      onSelect(null);
      setValue(null);
      setInitialValue(null);
    }
  }

  const onSelectOption = async (event, option, reason) => {
    if (!option)
      return;

    onSelect ? onSelect(option) : void 0;

    setValue(option.label);
    setInitialValue(option.label);
    setInnerState(true)
  }

  const waitChangeForm = waitInputComplete(onChange, 200);

  return (
    <div>
      <Autocomplete
        disablePortal
        options={options}
        onInputChange={waitChangeForm}
        onChange={onSelectOption}
        filterOptions={(options) => options}
        value={value}
        sx={{width: width || 230}}
        size='small'
        renderInput={(params) => <TextField {...params} value={value} error={error}
                                            label={`${label || "Адрес объекта"}`}/>}
      />
    </div>
  );
}